import { type FC, useMemo, type RefObject } from 'react';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTableV16';
import SpreadsheetV16 from '@/components/UI/SpreadSheet/SpreadsheetV16';
import type { SpreadsheetV16Settings } from '@/components/UI/SpreadSheet/SpreadsheetV16.model';
import { registerHOTModulesV16 } from '@/support/hot-v16';
import { ScoringScaleEditorV16 } from '@/components/UI/SpreadSheet/editors-v16/ScoringScaleEditorV16';
import { buildColumnsV16, initBulkAddObservationTypesSettingsV16 } from './BulkAddObservationTypes.utils';

import type { ValidationData } from '@/utils/observationTypeValidation';

registerHOTModulesV16();
ScoringScaleEditorV16.register();

export interface BulkAddObservationTypesTableV16Props {
  data: Array<Array<string>>;
  innerRef: RefObject<HotTableRef>;
  validationData: ValidationData | null;
  setInvalid: (invalid: boolean) => void;
}

const BulkAddObservationTypesTableV16: FC<BulkAddObservationTypesTableV16Props> = ({
  data,
  innerRef,
  validationData,
  setInvalid,
}) => {
  const columns = useMemo(
    () =>
      buildColumnsV16({
        validationData,
        hotTableRef: innerRef,
      }),
    [validationData, innerRef]
  );

  const settings = useMemo<SpreadsheetV16Settings>(() => initBulkAddObservationTypesSettingsV16(columns), [columns]);

  return (
    <div className="mv3 w-100 overflow-auto ow-spreadsheet-styles" data-testid="observation-types-spreadsheet">
      <SpreadsheetV16
        data={data}
        settings={settings}
        innerRef={innerRef}
        addCol={false}
        setInvalid={setInvalid}
        autoAddRow
        enableRowHeaderControls
        modalView
        fillHandle={false}
        testPrefix="bulk-add-observation-types-v16"
      />
    </div>
  );
};

export default BulkAddObservationTypesTableV16;
